import { Box, Typography } from '@mui/material';
import React from 'react';
import { TextButton } from '~/components/common/Buttons';
import Icon from '~/components/Icon';
import { Card } from '~/layouts/Card';
import { theme } from '~/theme';
import { I18n } from '../../i18n';
import { Color } from '~/constants/colors';

type props = {
  zoneId?: string | number;
  statusReason?: string;
  status?: string;
  statusColor?: string;
  customZone?: string;
  clickOnView?: () => void;
};
function AlertCard(zoneDetails: props) {
  return (
    <Card
      sx={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(1),
        }}
      >
        <Icon
          name="StatusDot"
          color={zoneDetails?.statusColor}
          isDecorative
          size={20}
        />
        <Typography variant="body1" fontWeight="bold">
          {zoneDetails?.status}
        </Typography>
      </Box>
      {zoneDetails?.statusReason && (
        <Typography
          variant="body2"
          overflow="hidden"
          textOverflow="ellipsis"
          lineHeight="16px"
        >
          {zoneDetails.statusReason}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            minWidth: 0,
            flexShrink: 1,
            padding: zoneDetails?.customZone ? '4px 8px' : 0,
            background: zoneDetails?.customZone ? Color.Grey50 : 'transparent',
            borderRadius:"6px"
          }}
        >
          {zoneDetails?.customZone && (
            <>
              <Icon
                name="MapSearch"
                size={15}
                color={theme.palette.text.secondary}
              />
              <Typography
                variant="body2"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                color={Color.NeutralGrey}
              >
                {zoneDetails.customZone}
              </Typography>
            </>
          )}
        </Box>
        <TextButton
          sx={{ fontWeight: 'bold' }}
          label={I18n.t('search.viewAlert')}
          onClick={() => {
            zoneDetails?.clickOnView?.();
          }}
          isEndIconVisible={true}
          endIcon={
            <Icon
              name="ArrowSmallRight"
              size={25}
              isDecorative
              color={theme.palette.primary.main}
            />
          }
        />
      </Box>
    </Card>
  );
}

export default AlertCard;